export default __webpack_public_path__ + "static/media/Javier-Marin-Software-Engineer-Resume-portfolio.414441c8.pdf";